'use strict';

global.utl = require('../utils.js');
global.cookieManager = require('../cookieManager.js');
